import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/available-plan-years/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const availablePlanYears = {
  getAll: apiPathFunc(pathBase),
};
